import { projectTypeConstants } from "../constant/projectType.constants";

export const initialState = {
    projectType: {
        id: '',
        projectTypeCode: '',
        projectTypeName: ''
    },
    dataProjectType: [
    ],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const projectTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case projectTypeConstants.GET_SUCCESS:
            return {
                ...state,
                dataProjectType: action.projectTypeList,
                isLoading: false
            };
        case projectTypeConstants.ADD_SUCCESS:
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };
        case projectTypeConstants.ADD_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };
        case projectTypeConstants.DELETE_SUCCESS:  
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };    
        case projectTypeConstants.DELETE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };  
        case projectTypeConstants.UPDATE_SUCCESS:  
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };    
        case projectTypeConstants.UPDATE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };  
        default:
            return state;
    }
};

export default projectTypeReducer;
